/* src/app/modules_v2/booking/components/booking-reports/operational-report/operational-report.component.scss */
.informe-operativo .seccion-grafico {
  margin-bottom: 2rem;
}
.informe-operativo .seccion-grafico h3 {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #4d4e56;
}
.informe-operativo .seccion-grafico .contenedor-grafico {
  position: relative;
  height: 280px;
}
.informe-operativo .seccion-kpis {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  margin-bottom: 3rem;
}
.informe-operativo .seccion-kpis .tarjeta-kpi {
  padding: 1.5rem;
  border-radius: 4px;
  text-align: center;
  color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s, box-shadow 0.2s;
}
.informe-operativo .seccion-kpis .tarjeta-kpi:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.informe-operativo .seccion-kpis .tarjeta-kpi.completada {
  background:
    linear-gradient(
      135deg,
      #28a745 0%,
      #20c997 100%);
}
.informe-operativo .seccion-kpis .tarjeta-kpi.cancelada {
  background:
    linear-gradient(
      135deg,
      #ffc107 0%,
      #fd7e14 100%);
}
.informe-operativo .seccion-kpis .tarjeta-kpi.nopresentada {
  background:
    linear-gradient(
      135deg,
      #dc3545 0%,
      #c82333 100%);
}
.informe-operativo .seccion-kpis .tarjeta-kpi.vacia {
  background:
    linear-gradient(
      135deg,
      #6c757d 0%,
      #495057 100%);
}
.informe-operativo .seccion-kpis .tarjeta-kpi .etiqueta-kpi {
  font-size: 0.875rem;
  opacity: 0.9;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.informe-operativo .seccion-kpis .tarjeta-kpi .valor-kpi {
  font-size: 1.75rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
}
.informe-operativo .seccion-kpis .tarjeta-kpi .unidad-kpi {
  font-size: 0.75rem;
  opacity: 0.8;
  text-transform: uppercase;
}
.informe-operativo .seccion-grafico {
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 1.5rem;
  margin-bottom: 2rem;
}
.informe-operativo .seccion-grafico h3 {
  margin: 0 0 1.5rem 0;
  color: #333;
  font-size: 1.1rem;
}
.informe-operativo .seccion-grafico .grafico-distribucion .barra-grafico {
  display: flex;
  height: 40px;
  border-radius: 2px;
  overflow: hidden;
  margin-bottom: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.informe-operativo .seccion-grafico .grafico-distribucion .barra-grafico .segmento-barra {
  flex-grow: 1;
  transition: all 0.3s;
}
.informe-operativo .seccion-grafico .grafico-distribucion .barra-grafico .segmento-barra:hover {
  opacity: 0.85;
}
.informe-operativo .seccion-grafico .grafico-distribucion .barra-grafico .segmento-barra.completada {
  background:
    linear-gradient(
      90deg,
      #28a745,
      #20c997);
}
.informe-operativo .seccion-grafico .grafico-distribucion .barra-grafico .segmento-barra.cancelada {
  background:
    linear-gradient(
      90deg,
      #ffc107,
      #fd7e14);
}
.informe-operativo .seccion-grafico .grafico-distribucion .barra-grafico .segmento-barra.nopresentada {
  background:
    linear-gradient(
      90deg,
      #dc3545,
      #c82333);
}
.informe-operativo .seccion-grafico .grafico-distribucion .leyenda-grafico {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
}
.informe-operativo .seccion-grafico .grafico-distribucion .leyenda-grafico .elemento-leyenda {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
}
.informe-operativo .seccion-grafico .grafico-distribucion .leyenda-grafico .elemento-leyenda .color-leyenda {
  width: 16px;
  height: 16px;
  border-radius: 2px;
}
.informe-operativo .seccion-grafico .grafico-distribucion .leyenda-grafico .elemento-leyenda .color-leyenda.completada {
  background:
    linear-gradient(
      135deg,
      #28a745,
      #20c997);
}
.informe-operativo .seccion-grafico .grafico-distribucion .leyenda-grafico .elemento-leyenda .color-leyenda.cancelada {
  background:
    linear-gradient(
      135deg,
      #ffc107,
      #fd7e14);
}
.informe-operativo .seccion-grafico .grafico-distribucion .leyenda-grafico .elemento-leyenda .color-leyenda.nopresentada {
  background:
    linear-gradient(
      135deg,
      #dc3545,
      #c82333);
}
.informe-operativo .seccion-tabla {
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 1.5rem;
}
.informe-operativo .seccion-tabla h3 {
  margin: 0 0 1.5rem 0;
  color: #333;
  font-size: 1.1rem;
}
.informe-operativo .seccion-tabla .tabla-responsiva {
  overflow-x: auto;
}
.informe-operativo .seccion-tabla .tabla-informe {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}
.informe-operativo .seccion-tabla .tabla-informe thead {
  background-color: #f5f5f5;
  border-bottom: 2px solid #ddd;
}
.informe-operativo .seccion-tabla .tabla-informe thead th {
  padding: 0.75rem;
  text-align: left;
  font-weight: 600;
  color: #333;
  text-transform: uppercase;
  font-size: 0.8rem;
  letter-spacing: 0.05em;
}
.informe-operativo .seccion-tabla .tabla-informe tbody tr {
  border-bottom: 1px solid #ddd;
  transition: background-color 0.2s;
}
.informe-operativo .seccion-tabla .tabla-informe tbody tr:hover {
  background-color: #f9f9f9;
}
.informe-operativo .seccion-tabla .tabla-informe tbody tr td {
  padding: 0.75rem;
  color: #333;
  text-align: center;
}
.informe-operativo .seccion-tabla .tabla-informe tbody tr td:first-child {
  text-align: left;
}
.informe-operativo .seccion-tabla .tabla-informe tbody tr td.metrica-completada {
  color: #28a745;
  font-weight: 600;
}
.informe-operativo .seccion-tabla .tabla-informe tbody tr td.metrica-cancelada {
  color: #ffc107;
  font-weight: 600;
}
.informe-operativo .seccion-tabla .tabla-informe tbody tr td.metrica-nopresentada {
  color: #dc3545;
  font-weight: 600;
}
.informe-operativo .seccion-tabla .sin-datos {
  text-align: center;
  color: #999;
  padding: 2rem;
  margin: 0;
}
@media (max-width: 768px) {
  .informe-operativo .seccion-kpis {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 1rem;
  }
  .informe-operativo .seccion-kpis .tarjeta-kpi {
    padding: 1rem;
  }
  .informe-operativo .seccion-kpis .tarjeta-kpi .valor-kpi {
    font-size: 1.25rem;
  }
  .informe-operativo .seccion-grafico {
    padding: 1rem;
  }
  .informe-operativo .seccion-grafico .grafico-distribucion .leyenda-grafico {
    flex-direction: column;
    gap: 0.75rem;
  }
  .informe-operativo .seccion-tabla {
    padding: 1rem;
  }
  .informe-operativo .seccion-tabla .tabla-informe {
    font-size: 0.75rem;
  }
  .informe-operativo .seccion-tabla .tabla-informe th,
  .informe-operativo .seccion-tabla .tabla-informe td {
    padding: 0.5rem;
  }
}
/*# sourceMappingURL=operational-report.component.css.map */
